import { useQuery } from "@apollo/react-hooks";
import { MY_HR_GET_FILTERED_LIST } from "my-hr/graphql";

interface UseMyHrFilteredListParams {
  page: number;
  pageSize: number;
  isActive?: boolean;
  roleFilters?: any; // Replace 'any' with a more specific type if available
  useOrLogic?: boolean;
}

export const useMyHrFilteredList = ({
  page,
  pageSize,
  isActive,
  roleFilters,
  useOrLogic,
}: UseMyHrFilteredListParams) => {
  const { data, error, loading, refetch } = useQuery(MY_HR_GET_FILTERED_LIST, {
    fetchPolicy: "cache-and-network",
    variables: { page, pageSize, isActive, roleFilters, useOrLogic },
  });

  const list = data?.filteredList?.rows || [];

  interface FilteredListItem {
    employee: {
      code: string;
      prefixName: string;
      lastName: string;
      firstName: string;
      middleName: string;
      nameSuffix: string;
    };
    code: string;
    orgUnit: {
      name: string;
    };
    jobClass: {
      name: string;
    };
    _id: string;
  }

  const parsedList = (list as FilteredListItem[]).map((item) => {
    const newItem = {
      employee: item.employee.code,
      contract: item.code,
      fullname:
        `${item.employee.prefixName} ${item.employee.lastName} ${item.employee.firstName} ${item.employee.middleName} ${item.employee.nameSuffix}`.trim(),
      orgUnit: item.orgUnit.name,
      jobClass: item.jobClass?.name || "-", // Handle null jobClass
      _id: item._id,
    };
    return newItem;
  });

  const result = {
    page: data?.filteredList?.page,
    pageSize: data?.filteredList?.pageSize,
    total: data?.filteredList?.total,
    totalPages: data?.filteredList?.totalPages,
    rows: parsedList,
  };

  return {
    data: result,
    error,
    loading,
    refetch,
  };
};

export default useMyHrFilteredList;
